import { setRefreshStatus } from '../actions/internalActions';
import { setLinkActionStatus } from '../actions/publicActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(setRefreshStatus, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (sharingLink) {
        sharingLink.linkActionStatus = actionMessage.actionStatus;
    }
});

mutator(setLinkActionStatus, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (sharingLink) {
        sharingLink.linkActionStatus = actionMessage.linkActionStatus;
    }
});
